import { render, staticRenderFns } from "./tagging.vue?vue&type=template&id=18a7da64&"
import script from "./tagging.vue?vue&type=script&lang=js&"
export * from "./tagging.vue?vue&type=script&lang=js&"
import style0 from "./tagging.vue?vue&type=style&index=0&id=18a7da64&prod&lang=less&"
import style1 from "./tagging.vue?vue&type=style&index=1&id=18a7da64&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports